/**
 * PROTOTYPE CONTENT — NOT VERIFIED. Restored verbatim from `design-reference/`.
 *
 * Safety statistics and certifications are the two things a client verifies
 * first, and the two things that end a relationship fastest when they turn out
 * to be overstated. None of the figures or certifications below are evidenced by
 * a register, an audit report or a certificate. See CONTENT-STATUS.md.
 */
export interface SafetyStat {
  value: string
  label: string
}

export const safetyStats: SafetyStat[] = [
  { value: '46 000', label: 'Site hours worked' },
  { value: '0', label: 'Lost-time injuries' },
  { value: '0', label: 'Reportable incidents' },
  { value: '14', label: 'Site audits since March' },
]

export const safetyIntro =
  'Our SHEQ management system is built to ISO 45001 and audited internally every month, with the certification audit scheduled for the second quarter of 2027. It is not a document set — it is what the site agent runs the day on.'

export interface Practice {
  no: string
  text: string
}

export const safetyPractices: Practice[] = [
  { no: '01', text: 'Section 37(2) mandatory agreement in place before any person enters site.' },
  { no: '02', text: 'Daily task-based risk assessment and toolbox talk, signed by every crew.' },
  { no: '03', text: 'Full induction with site-specific hazards before first shift — no exceptions for visitors.' },
  { no: '04', text: 'Stop-work authority held by every employee, protected from consequence.' },
  { no: '05', text: 'ICAM investigation on all high-potential incidents, findings circulated group-wide.' },
  { no: '06', text: 'Independent monthly SHEQ audit with corrective actions closed out in 14 days.' },
]

export interface Certification {
  name: string
  note: string
}

export const certifications: Certification[] = [
  {
    name: 'CIDB 6CE / 6GB PE',
    note: 'Registered May 2026 on financial capability, potentially-emerging status. Grade 7 targeted for 2027.',
  },
  {
    name: 'B-BBEE Level 1',
    note: 'EME status confirmed by sworn affidavit. 100% black-owned, 135% procurement recognition.',
  },
  {
    name: 'OHS Act 85/1993',
    note: 'Construction Regulations 2014 compliance with appointed CR8 construction supervisors.',
  },
  {
    name: 'MHSA 29/1996',
    note: 'Mine-site systems in place for the Mpumalanga and North West contracts.',
  },
  {
    name: 'ISO 45001',
    note: 'Management system built to the standard. Certification audit scheduled for Q2 2027.',
  },
  { name: 'COIDA', note: 'Letter of good standing current. No claims on record.' },
]

export const environmentalNote =
  'Every contract runs against an approved Environmental Management Programme with an appointed ECO. We report water use, waste diversion and rehabilitation progress monthly to the client and the relevant authority — on all six contracts, without exception.'
